export default __webpack_public_path__ + "static/media/626.7c59beeb.png";